<template>
  <div class="loading-background">
    <div class="loading-header">
      <img src="/img/OT_Icon_Transparent.png" class="ot-logo"/>
      <icon :icon="['fal', 'spinner']" spin size="3x"/>
      {{$t("loading.staticData")}}
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingView",
  props: {
    progress: Number
  },
  data: function () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/global";

.loading-header {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  position: absolute;
  margin: auto 0;
  color: white;
  gap: 2em;
}

.loading-background {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-size: 400% 400%;
  animation: moving-bg-loading 15s ease infinite;
  background: linear-gradient(45deg, #262C32 50%, #414b55 100%);
  padding: 0 0;
  margin: 0 0;
  user-select: none;
}

@keyframes moving-bg-loading {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}

.ot-logo {
  width: 512px;
}

.loader {
  position: absolute;
  top: 176px;
  left: 132.75px;
  width: 76px;
  height: 15px;
  background-color: white;
}

@keyframes moving-bg {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}
</style>